import { render, staticRenderFns } from "./product-list2.vue?vue&type=template&id=bc26ce18&lang=pug&"
import script from "./product-list2.vue?vue&type=script&lang=js&"
export * from "./product-list2.vue?vue&type=script&lang=js&"
import style0 from "./product-list2.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports